'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

const GOOGLE_MAPS_URL =
  'https://www.google.com/travel/search?q=Hotel%20Subeksha%2C%20Adityapur&g2lb=4965990%2C72471280%2C72560029%2C72573224%2C72647020%2C72686036%2C72803964%2C72882230%2C72958624%2C73059275%2C73064764%2C73249147&hl=en-IN&gl=in&cs=1&ssta=1&ts=CAEaRwopEicyJTB4MzlmNWU1ODU5Y2Y0ZDk0ZDoweDFmNmM4YmI5OGE3NjEyYjcSGhIUCgcI6g8QAhgUEgcI6g8QAhgVGAEyAhAA&qs=CAEyE0Nnb0l0NlhZMDVqM29yWWZFQUU4AkIJCbcSdoq5i2wf&ap=ugEHcmV2aWV3cw&ictx=111&ved=0CAAQ5JsGahcKEwjQ8unuvbCSAxUAAAAAHQAAAAAQBA';

const RestaurantInfo = () => {
  const contactMethods = [
    {
      icon: 'PhoneIcon',
      label: 'Phone',
      value: '+91 75420 72555',
      href: 'tel:+15551234567',
      description: 'Call us for immediate assistance',
    },
    {
      icon: 'EnvelopeIcon',
      label: 'Email',
      value: 'hello@heydgreen.com',
      href: 'mailto:hello@heydgreen.com',
      description: 'Send us an email anytime',
    },
    {
      icon: 'ChatBubbleLeftRightIcon',
      label: 'WhatsApp',
      value: '+91 75420 72555',
      href: 'https://wa.me/15551234567',
      description: 'Chat with us on WhatsApp',
    },
  ];

  const businessHours = [
    { days: 'Monday - Friday', hours: '12:00 PM - 11:00 PM' },
    { days: 'Saturday', hours: '12:00 PM - 10:00 PM' },
    { days: 'Sunday', hours: '12:00 PM - 10:00 PM' },
  ];

  const socialLinks = [
    { icon: 'facebook', label: 'Facebook', href: '#' },
    { icon: 'twitter', label: 'Twitter', href: '#' },
    { icon: 'instagram', label: 'Instagram', href: '#' },
  ];

  return (
    <div className="space-y-6">
      {/* Contact Methods */}
      <div className="rounded-lg bg-card shadow-md">
        <div className="border-b border-border px-6 py-4">
          <h2 className="font-heading text-xl font-semibold text-foreground">
            Contact Information
          </h2>
        </div>
        <div className="space-y-4 px-6 py-6">
          {contactMethods?.map((method, index) => (
            <a
              key={index}
              href={method?.href}
              className="flex items-start space-x-4 rounded-lg border border-border bg-background p-4 transition-smooth hover:border-primary hover:shadow-sm focus-ring"
            >
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-primary/10">
                <Icon name={method?.icon} size={24} className="text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-foreground">{method?.label}</h3>
                <p className="mt-1 text-sm font-medium text-primary">{method?.value}</p>
                <p className="mt-0.5 text-xs text-muted-foreground">{method?.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
      {/* Location & Map */}
      <div className="rounded-lg bg-card shadow-md">
        <div className="border-b border-border px-6 py-4">
          <h2 className="font-heading text-xl font-semibold text-foreground">Our Location</h2>
        </div>
        <div className="px-6 py-6">
          <div className="mb-4 flex items-start space-x-3">
            <Icon name="MapPinIcon" size={20} className="mt-0.5 text-primary" />
            <div>
              <p className="text-sm font-medium text-foreground">Hotel Subeksha</p>
              <p className="text-sm text-muted-foreground">Adityapur, Jharkhand, India</p>
            </div>
          </div>

          {/* Static map image preview from assets */}
          <div className="relative aspect-video overflow-hidden rounded-lg bg-muted">
            <AppImage
              src="/assets/map.png"
              alt="Map preview for Hotel Subeksha in Adityapur, Jharkhand, India"
              className="h-full w-full object-cover"
            />
          </div>

          {/* Open in Maps button */}
          <a
            href={GOOGLE_MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center space-x-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-smooth hover:bg-primary/90 focus-ring"
          >
            <Icon name="ArrowTopRightOnSquareIcon" size={16} />
            <span>Open in Google Maps</span>
          </a>
        </div>
      </div>
      {/* Business Hours */}
      <div className="rounded-lg bg-card shadow-md">
        <div className="border-b border-border px-6 py-4">
          <h2 className="font-heading text-xl font-semibold text-foreground">Business Hours</h2>
        </div>
        <div className="space-y-3 px-6 py-6">
          {businessHours?.map((schedule, index) => (
            <div key={index} className="flex items-center justify-between">
              <span className="text-sm font-medium text-foreground">{schedule?.days}</span>
              <span className="text-sm text-muted-foreground">{schedule?.hours}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Social Media */}
      <div className="rounded-lg bg-card shadow-md">
        <div className="border-b border-border px-6 py-4">
          <h2 className="font-heading text-xl font-semibold text-foreground">Follow Us</h2>
        </div>
        <div className="px-6 py-6">
          <div className="flex space-x-4">
            {socialLinks?.map((social, index) => (
              <a
                key={index}
                href={social?.href}
                className="flex h-12 w-12 items-center justify-center rounded-lg border border-border bg-background transition-smooth hover:border-primary hover:bg-primary/5 focus-ring"
                aria-label={social?.label}
              >
                <Icon name="ShareIcon" size={20} className="text-primary" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestaurantInfo;
